'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialHtml5 = function IoSocialHtml5(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5 2.5h30l-2.7 31.5-12.3 3.5-12.3-3.5z m24.1 10.3l0.3-3.9h-18.9l1.1 11.7h13l-0.5 5-4.1 1.2-4.2-1.2-0.3-3h-3.7l0.5 6.1 7.7 2.1 7.7-2.2 1.1-11.8h-13.8l-0.3-4h14.4z' })
        )
    );
};

exports.default = IoSocialHtml5;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-html5.js
// module id = 2451
// module chunks = 0